import { buildSsoAuthorizeUrl } from "@4nk/sso-sdk/oauth";
import { computePkceCodeChallenge, generatePkceCodeVerifier } from "@4nk/sso-sdk/pkce";

function storageSuffix(): string {
	if (typeof window === "undefined") {
		return "server";
	}
	return window.location.host;
}

export function ssoOAuthStateStorageKey(): string {
	return `sso_oauth_state:${storageSuffix()}`;
}

export function ssoOAuthCodeVerifierStorageKey(): string {
	return `sso_oauth_code_verifier:${storageSuffix()}`;
}

export async function startSsoPkceAuthorizeRedirect(params: {
	clientId: string;
	authorizeBaseUrl: string;
	redirectUri: string;
	loginHint?: string;
}): Promise<void> {
	const state = crypto.randomUUID();
	const codeVerifier = generatePkceCodeVerifier();
	const codeChallenge = await computePkceCodeChallenge(codeVerifier);
	sessionStorage.setItem(ssoOAuthStateStorageKey(), state);
	sessionStorage.setItem(ssoOAuthCodeVerifierStorageKey(), codeVerifier);
	const authorizeUrl = buildSsoAuthorizeUrl({
		authorizeBaseUrl: params.authorizeBaseUrl,
		clientId: params.clientId,
		redirectUri: params.redirectUri,
		state,
		codeChallenge,
		loginHint: params.loginHint,
	});
	window.location.assign(authorizeUrl);
}

export function consumeSsoPkceCallbackParams(
	code: string,
	returnedState: string,
): { ok: true; codeVerifier: string } | { ok: false } {
	const expectedState = sessionStorage.getItem(ssoOAuthStateStorageKey());
	const codeVerifier = sessionStorage.getItem(ssoOAuthCodeVerifierStorageKey());
	sessionStorage.removeItem(ssoOAuthStateStorageKey());
	sessionStorage.removeItem(ssoOAuthCodeVerifierStorageKey());
	if (
		expectedState === null ||
		expectedState !== returnedState ||
		codeVerifier === null ||
		codeVerifier.length === 0
	) {
		return { ok: false };
	}
	return { ok: true, codeVerifier };
}

export function clearSsoPkceSessionArtifacts(): void {
	sessionStorage.removeItem(ssoOAuthStateStorageKey());
	sessionStorage.removeItem(ssoOAuthCodeVerifierStorageKey());
}
